export default {
  language: 'zh_CN',
  storageOptions: {
    namespace: 'srm_',
    name: 'ls',
    storage: 'local'
  }
}
